<mc-form [formGroup]="syndicateForm" [submitFn]="submitFn" [successMessage]="successMessage" [errorMessage]="errorMessage" [deleteFn]="connector ? deleteFn : null" [deleteConfirmDialogData]="deleteConfirmDialogData" [deleteSuccessMessage]="deleteSuccessMessage" (success)="success.emit($event)" (cancel)="cancel.emit($event)">
  <ng-template mcFormBody>

    <p class="mc-form-heading">Settings</p>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Name</mat-label>
      <input type="text" matInput formControlName="syndicateName" placeholder="Name" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="syndicateForm" controlName="syndicateName" type="mc_connector_name"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Elevate URL</mat-label>
      <input type="text" matInput formControlName="elevateUrl" placeholder="Elevate URL" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="syndicateForm" controlName="elevateUrl" type="mc_url"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Syndicate URL</mat-label>
      <input type="text" matInput formControlName="syndicateUrl" placeholder="Syndicate URL" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="syndicateForm" controlName="syndicateUrl" type="mc_url"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <p class="mc-form-heading">Authentication</p>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Client ID </mat-label>
      <input type="text" matInput formControlName="clientId" placeholder="Client ID" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="syndicateForm" controlName="clientId" type="mc_client_id"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!syndicateApiKeyControlHide" class="mc-form-field" mcColor="secondary">
      <mat-label>API Key</mat-label>
      <input type="text" class="mc-form-password-input-edge-eye-hidden" formControlName="apiKey" autocomplete="new-password" matInput class="mc-form-password-input-edge-eye-hidden" placeholder="API Key" [type]="apiKeyHide ? 'password' : 'text'">
      <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="apiKeyHide = !apiKeyHide"></mat-icon>
      <mat-error>
        <mc-form-control-error-message [form]="syndicateForm" controlName="apiKey" type="mc_api_key"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>
    <button *ngIf="syndicateApiKeyControlHide" mat-stroked-button (click)="enableApiKeyControl()">Change API Key</button>

  </ng-template>
</mc-form>